import React, { RefObject, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './general-section.module.scss';
import ListIcon from './list-icon';

type Props = {
  children: JSX.Element[] | JSX.Element,
  title: string,
  icon: string,
  items_count: number,
  linkToAll?: string
};

const GeneralSection: React.FC<Props> = ({ children, title, icon, items_count, linkToAll }) => {
  const itemsRef: RefObject<HTMLDivElement> = useRef(null);
  const scrollSize = 315;
  const [leftScroller, setLeftScroller] = useState<boolean>(false);
  const [rightScroller, setRightScroller] = useState<boolean>(false);

  const elementsSize = () => {
    if (typeof itemsRef.current === "undefined")
      return 0;
    const firstChild = itemsRef.current?.firstElementChild as HTMLDivElement;
    return ((firstChild?.offsetWidth || 300) + 15) * items_count;
  };

  const animateScroll = (elem: HTMLElement, from: number, to: number, time: number) => {
    if (!elem) {
      return;
    }
    const start = new Date().getTime();
    const timer = setInterval(function () {
      var step = Math.min(1, (new Date().getTime() - start) / time);
      elem.scrollLeft = from + (to - from) * step;
      if (step === 1) {
        clearInterval(timer);
      }
    }, 25);
  }

  const scrollRight = () => {
    if (typeof itemsRef.current === "undefined")
      return;
    const itemsContainer = itemsRef.current as HTMLDivElement;
    animateScroll(itemsContainer, itemsContainer.scrollLeft, itemsContainer.scrollLeft + scrollSize, 200);
  };

  const scrollLeft = () => {
    if (typeof itemsRef.current === "undefined")
      return;
    const itemsContainer = itemsRef.current as HTMLDivElement;
    animateScroll(itemsContainer, itemsContainer.scrollLeft, itemsContainer.scrollLeft - scrollSize, 200);
  }

  const updateScrollers = () => {
    if (typeof itemsRef.current === "undefined")
      return;
    const itemsContainer = itemsRef.current as HTMLDivElement;
    setRightScroller(Math.abs(itemsContainer.scrollLeft) > 0);
    setLeftScroller(Math.abs(itemsContainer.scrollLeft) < elementsSize() - itemsContainer.offsetWidth);
  };

  useEffect(() => {
    updateScrollers();
    window.addEventListener('resize', updateScrollers);
    return () => window.removeEventListener('resize', updateScrollers);
  }, [itemsRef.current]);

  return (
    <section className={styles.itemsSection}>
      <div className={styles.title}>
        <h3>
          <ListIcon icon={icon} /> {title}
          {linkToAll ? (
            <Link className={styles.linkToAll} to={linkToAll}>مشاهده همه</Link>
          ) : ''}
        </h3>
        <div className={styles.scroller}>
          <ListIcon icon={"leftScroller" + (leftScroller ? '' : 'Inactive')} onClick={scrollLeft} />
          <ListIcon icon={"rightScroller" + (rightScroller ? '' : 'Inactive')} onClick={scrollRight} />
        </div>
      </div>
      <div ref={itemsRef} onScroll={updateScrollers} className={styles.items + ' row'}>
        {children}
      </div>
    </section>
  );
}

export default GeneralSection;
